import { useMediaQuery } from "@mui/material";

export const useIsMobileImage = () => {
  return useMediaQuery("(max-width:850px)");
};

export const useIsMobileNavBar = () => {
  return useMediaQuery("(max-width:600px)");
};
